// Ordenación por cabecera para cualquier <table> de la app que no tenga ya su propio SortHeader.
const NUM = /^[+\-−]?\d[\d.]*(,\d+)?\s*(€|%|pp|uds?\.?|días|d|x|×)?$/i;
const state = new WeakMap();

function cellAt(row, col) {
  let i = 0;
  for (const c of row.cells) {
    if (col >= i && col < i + c.colSpan) return c;
    i += c.colSpan;
  }
  return null;
}

function valueOf(cell) {
  if (!cell) return null;
  if (cell.dataset.sort != null) { const n = Number(cell.dataset.sort); return Number.isNaN(n) ? cell.dataset.sort : n; }
  const inp = cell.querySelector("input,select");
  const t = (inp ? inp.value : cell.innerText || "").trim().split("\n")[0].trim();
  if (!t || t === "—" || t === "-") return null;
  const d = t.match(/^(\d{1,2})\/(\d{1,2})\/(\d{2,4})/);
  if (d) return new Date(+(d[3].length === 2 ? `20${d[3]}` : d[3]), +d[2] - 1, +d[1]).getTime();
  if (/^\d{4}-\d{2}-\d{2}/.test(t)) return Date.parse(t.slice(0, 10));
  const s = t.replace(/\u00a0/g, " ");
  if (NUM.test(s)) return parseFloat(s.replace(/[^\d,.\-−+]/g, "").replace(/\./g, "").replace(",", ".").replace("−", "-"));
  return t.toLocaleLowerCase("es");
}

function columnOf(th) {
  let i = 0;
  for (const c of th.parentElement.cells) { if (c === th) return i; i += c.colSpan; }
  return -1;
}

function apply(table) {
  const st = state.get(table);
  if (!st) return;
  st.busy = true;
  for (const tb of table.tBodies) {
    const groups = [], top = [], bottom = [];
    for (const r of [...tb.rows]) {
      const first = (r.cells[0]?.innerText || "").trim().toLowerCase();
      if (r.dataset.sortFixed != null || first.startsWith("total")) bottom.push(r);
      else if (r.cells.length === 1 && r.cells[0].colSpan > 1) (groups.length ? groups[groups.length - 1].push(r) : top.push(r));
      else groups.push([r]);
    }
    if (groups.length < 2) continue;
    const dir = st.dir === "asc" ? 1 : -1;
    const vals = new Map(groups.map((g) => [g, valueOf(cellAt(g[0], st.col))]));
    groups.sort((a, b) => {
      const va = vals.get(a), vb = vals.get(b);
      if (va == null && vb == null) return 0;
      if (va == null) return 1;
      if (vb == null) return -1;
      if (typeof va === "number" && typeof vb === "number") return (va - vb) * dir;
      return String(va).localeCompare(String(vb), "es", { numeric: true }) * dir;
    });
    const order = [...top, ...groups.flat(), ...bottom];
    if (order.some((r, i) => tb.rows[i] !== r)) order.forEach((r) => tb.appendChild(r));
  }
  requestAnimationFrame(() => { st.busy = false; });
}

function mark(table) {
  const st = state.get(table);
  table.querySelectorAll("thead th").forEach((th) => {
    th.classList.remove("gsort-asc", "gsort-desc");
    if (st && th === st.th) th.classList.add(st.dir === "asc" ? "gsort-asc" : "gsort-desc");
  });
}

function sortable(th) {
  const table = th.closest("table");
  return table && !table.hasAttribute("data-nosort") && th.closest("thead") && (th.innerText || "").trim() &&
    !th.querySelector("button,input,select,a,[role=button]");
}

function onClick(e) {
  const th = e.target.closest && e.target.closest("th");
  if (!th) return;
  const tbl = th.closest("table");
  if (!sortable(th)) return;
  const table = th.closest("table");
  const col = columnOf(th);
  const prev = state.get(table);
  const sample = [...(table.tBodies[0]?.rows || [])].map((r) => valueOf(cellAt(r, col))).find((v) => v != null);
  const dir = prev && prev.col === col ? (prev.dir === "asc" ? "desc" : "asc") : typeof sample === "number" ? "desc" : "asc";
  if (prev?.obs) prev.obs.disconnect();
  const st = { col, dir, th, busy: false, orig: prev?.orig || [...table.tBodies].map((tb) => [...tb.rows]) };
  st.obs = new MutationObserver(() => { if (!st.busy) requestAnimationFrame(() => apply(table)); });
  for (const tb of table.tBodies) st.obs.observe(tb, { childList: true });
  state.set(table, st);
  apply(table);
  mark(table);
}

// Antes de que React reordene (SortHeader propio), devuelve las filas al orden que React conoce.
function onCapture(e) {
  const th = e.target.closest && e.target.closest("thead th");
  const table = th && th.closest("table");
  const st = table && state.get(table);
  if (!st || !e.target.closest("button")) return;
  st.obs?.disconnect();
  [...table.tBodies].forEach((tb, i) => {
    const known = (st.orig[i] || []).filter((r) => r.parentNode === tb);
    const rest = [...tb.rows].filter((r) => !known.includes(r));
    [...known, ...rest].forEach((r) => tb.appendChild(r));
  });
  state.delete(table);
  mark(table);
}

export function installGlobalTableSort() {
  if (window.__gsort) return;
  window.__gsort = true;
  document.addEventListener("click", onCapture, true);
  document.addEventListener("click", onClick);
}
